export async function readJsonResponse(
  responseOrPromise,
  defaultMessage = "Failed to complete the request."
) {
  const response = await responseOrPromise;
  if (!response) {
    const error = new Error(defaultMessage);
    error.status = 500;
    throw error;
  }
  const contentType = response.headers?.get("content-type") || "";
  let payload = null;
  if (contentType.includes("application/json")) {
    try {
      payload = await response.json();
    } catch {
      payload = null;
    }
  } else {
    try {
      payload = await response.text();
    } catch {
      payload = null;
    }
  }
  if (!response.ok) {
    const error = new Error(payload?.message || defaultMessage);
    error.status = response.status;
    error.data = payload;
    throw error;
  }
  return payload;
}

